module.exports = __webpack_public_path__ + "img/TW.5288ee42.svg";